import gql from 'graphql-tag';
import { ORDER_FRAGMENT } from './order';

/**
 * 分销统计
 */
export const DISTRIBUTOR_STATISTICS_FRAGMENT = gql`
  fragment DistributorStatistics on DistributorStatistics {
    effectiveOrderNum
    orderTotal
    accumulationAmount
    orderTotalAmount
    distributorId
    distributorGroupId
    effectiveCustomerNum
    customerCount
    memberCustomerTotalCount
    memberCustomerEffectiveCount
  }
`;

/**
 * 分销订单
 */
export const DISTRIBUTOR_ORDER_FRAGMENT = gql`
  fragment DistributorOrder on DistributorOrder {
    id
    createdAt
    updatedAt
    order {
      customer {
        id
        lastName
        phoneNumber
        customFields {
          headPortrait
        }
      }
      ...Order
    }
  }
  ${ORDER_FRAGMENT}
`;

/**
 * 分销员
 */
// export const DISTRIBUTOR_FRAGMENT = gql`
//   fragment Distributor on Distributor {
//     id
//     createdAt
//     updatedAt
//     name
//     phone
//     customer {
//       ...Customer
//     }
//     distributorOrders {
//       ...DistributorOrder
//     }
//     distributorGroup {
//     }
//     orderTotal
//     customerCount
//     effectiveCustomerNum
//     distributorGroupId
//     distributorGroupName
//     effectiveOrderNum
//     accumulationAmount
//     orderTotalAmount
//     detailTime
//     presentGroupId
//   }
//   ${CUSTOMER_FRAGMENT}
//   ${DISTRIBUTOR_ORDER_FRAGMENT}
// `;
